// 首页路由

export default {
  path: "/index",
  name: "home",
  roles: ["all"],
  component: () => import(/* webpackChunkName: "home" */ "@/views/home"),
  meta: { title: "首页", icon: "home", affix: true },
};
